<se-fe-button seFeDataEmphasis="low" (click)="open($event.currentTarget)">Choose products</se-fe-button>

<se-fe-modal #modal seFeDataSize="large" seFeDataTitle="Choose products" (seFeAfterClose)="modalClosed()">
  <se-fe-modal-content>
    @if (error(); as loadError) {
      <se-fe-alert seFeDataType="error">{{ loadError.message }}</se-fe-alert>
    }

    <product-selection-table
      [products]="products()"
      [loading]="loading()"
      [paginationOptions]="paginationOptions()"
      [query]="query()"
      [selectedProductIds]="selectedProductIds()"
      [paginationEnabled]="true"
      [showSearch]="true"
      [hideSearchWhenEmpty]="true"
      [sortBy]="sortBy()"
      [sortDirection]="sortDirection()"
      (queryChanged)="queryChanged($event)"
      (selectionChanged)="selectionChanged($event)"></product-selection-table>

    @if (saveError(); as addError) {
      <se-fe-alert seFeDataType="error">{{ addError.message }}</se-fe-alert>
    }

    <div class="catalog-product-chooser__footer">
      @if (selectedCount() > 0) {
        <span class="catalog-product-chooser__selection-count">{{ selectedCount() }} selected</span>
      }
      <se-fe-button seFeDataEmphasis="low" [seFeDataIsDisabled]="saving()" (click)="close()">Cancel</se-fe-button>
      <se-fe-button
        seFeDataEmphasis="high"
        [seFeDataIsDisabled]="selectedCount() === 0 || saving()"
        [seFeDataIsLoading]="saving()"
        seFeDataLoadingLabel="Adding products"
        (click)="addSelectedProducts()">
        Add products
      </se-fe-button>
    </div>
  </se-fe-modal-content>
</se-fe-modal>
